// @flow

import { combineReducers, type Reducer } from 'redux';

import {
  createSequoiaResource,
  type SequoiaResource,
  type SequoiaResourceType,
  type DetailState,
  type ResourceAction,
} from '@gandi/resource/redux';

export type Account = {
  automatic: boolean,
  balance?: {
    currency: string,
    price_after_taxes: number,
  },
  consumption: {
    current: {
      currency: string,
      normal_price_after_taxes: number,
      price_after_taxes: number,
    },
  },
};

export type State = {
  detail: DetailState<Account>,
};

type AccountsResourceType = SequoiaResourceType<{
  fetchOneResource: Account,
}>;

export type AccountsResource = SequoiaResource<AccountsResourceType>;

export const accountsResource: AccountsResource = createSequoiaResource(
  'cloud',
  'accounts',
  {
    fetchOnePath: 'balance/accounts/{sharing_id}',
  },
);

export const reducer: Reducer<State, ResourceAction<>> = combineReducers({
  ...accountsResource.detailReducer,
});
